// material-ui
import realescy from 'assets/images/icons/realescy.svg';
import newSvgFile from 'assets/images/icons/RealEsCy_2.svg';
import PropTypes from 'prop-types';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const Logo = ({ open }) => {
  const size = open ? '50pt' : '40pt';

  return (
    /**
     * if you want to use image instead of svg uncomment following, and comment out <svg> element.
     *
     * <img src={logo} alt="Mantis" width="100" />
     *
     */
    <>
      <img src={newSvgFile} alt="New Logo" width={size} height={size} />
      {open && <img src={realescy} alt="Logo" />}
    </>
  );
};

export default Logo;

Logo.propTypes = {
  open: PropTypes.boolean
};
